import { delay } from 'redux-saga';
import { fork, put, take, takeLatest } from 'redux-saga/effects';
import {
    putAndWaitAPI,
    putAndWaitHandleAllAPIError,
    selectAPI
} from '../../api/API.sagas';
import * as apiActions from '../../api/lendingAPI/LendingAPI.actions';
import { CLOSE_MODAL, OPEN_MODAL } from '../../iwModals/Modals.actions';
import { createWorkersForPage } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';
import * as actions from './TradingData.actions';
import { isTradingDataLocation } from './TradingDataHelper';

export const tradingDataSagaWorkers = createWorkersForPage({
    page: 'TRADING_DATA',
    isInPageLocation: isTradingDataLocation,
    createPageFlowWorkers: () => [
        fork(tradingDataPageWorker),
        fork(unlinkLinkedAccountWorker)
    ]
});

function* tradingDataPageWorker() {
    yield takeLatest(actions.ACTIVATE_TRADING_DATA, function* () {
        yield put({ type: actions.TRADING_DATA_DATA_LOADING });

        yield putAndWaitHandleAllAPIError([
            { type: apiActions.API_GET_CUSTOMER_STATE },
            { type: apiActions.API_GET_DOCUMENT_UPLOAD },
            { type: apiActions.API_GET_ONLINE_ACCOUNT },
            { type: apiActions.API_GET_ACCOUNTS },
            { type: apiActions.API_GET_APPLICATION }
        ]);

        const {
            customer_state,
            document_upload,
            online_account,
            site_context
        } = yield selectAPI();
        // Banks supported pre-truelayer
        const openBankingBanks = site_context?.open_banking?.banks ?? [];
        const trueLayerBanks =
            site_context?.open_banking?.truelayer_banks ?? [];

        const allOpenBankingBanks = [...openBankingBanks, ...trueLayerBanks];

        yield put({
            type: actions.TRADING_DATA_DATA,
            customer_state,
            document_upload,
            online_account,
            allOpenBankingBanks
        });
    });
}

function* unlinkLinkedAccountWorker() {
    yield takeLatest(actions.UNLINK_LINKED_ACCOUNT, function* (action) {
        yield put({
            type: actions.SET_UNLINKING_ACCOUNT,
            onlineAccountName: action.onlineAccountName
        });

        yield put({ type: OPEN_MODAL, id: 'UnlinkLinkedAccountModal' });

        const nextAction = yield take([
            actions.CONFIRM_UNLINKING_ACCOUNT,
            CLOSE_MODAL
        ]);

        if (nextAction.type === actions.CONFIRM_UNLINKING_ACCOUNT) {
            const deleteAccountNextAction = yield putAndWaitAPI({
                type: apiActions.API_DELETE_ONLINE_ACCOUNT,
                onlineAccountId: action.onlineAccountId
            });

            switch (deleteAccountNextAction.type) {
                case apiActions.API_DELETE_ONLINE_ACCOUNT_SUCCESS:
                    yield put({ type: actions.UNLINKING_ACCOUNT_SUCCESS });
                    yield delay(1000);
                    yield put({ type: apiActions.API_GET_ONLINE_ACCOUNT });
                    yield take(apiActions.API_GET_ONLINE_ACCOUNT_SUCCESS);

                    const { online_account, site_context } = yield selectAPI();
                    // Banks supported pre-truelayer
                    const openBankingBanks = site_context?.open_banking?.banks;
                    const trueLayerBanks =
                        site_context?.open_banking?.truelayer_banks;

                    const allOpenBankingBanks = [
                        ...openBankingBanks,
                        ...trueLayerBanks
                    ];

                    yield put({
                        type: actions.SET_TRADING_DATA_LINKED_ACCOUNTS,
                        online_account,
                        allOpenBankingBanks
                    });

                    yield put({ type: CLOSE_MODAL });
                    break;

                case apiActions.API_DELETE_ONLINE_ACCOUNT_FAIL:
                    yield put({ type: actions.UNLINKING_ACCOUNT_FAIL });
                    yield delay(1000);
                    yield put({ type: CLOSE_MODAL });
                    break;
            }
        }
    });
}
